const MARK = "/logo-mark.png";

const SIZES = {
  sm: { mark: "h-7", brand: "text-lg", sub: "text-[8px]", gap: "gap-2" },
  md: { mark: "h-7 sm:h-9", brand: "text-base sm:text-xl", sub: "text-[8px] sm:text-[9px]", gap: "gap-2 sm:gap-2.5" },
  lg: { mark: "h-16 md:h-20", brand: "text-4xl md:text-5xl", sub: "text-xs md:text-sm", gap: "gap-4" },
};

export default function Logo({ size = "md", className = "", glow = false }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex min-w-0 items-center ${s.gap} ${className}`}>
      <img
        src={MARK}
        alt="StratFlow Tech"
        className={`${s.mark} w-auto shrink-0 ${glow ? "drop-shadow-[0_6px_24px_rgba(0,122,255,0.4)]" : "drop-shadow-[0_3px_8px_rgba(15,23,42,0.3)]"}`}
      />
      <span className="flex min-w-0 flex-col leading-none">
        <span className={`font-display font-extrabold tracking-tight text-slate-900 ${s.brand}`}>
          STRAT<span className="text-blue-600"> FLOW</span>
        </span>
        <span className={`font-mono-x tracking-[0.3em] text-slate-600 ${s.sub} mt-1`}>
          TECH FZCO
        </span>
      </span>
    </span>
  );
}
